export enum NeedToKnowVisibilityLevel {
  MGALevel = 'mga',
  ProspectLevel = 'prospect',
  AgencyLevel = 'agencyLevel',
  AllianceGroupLevel = 'allianceGroupLevel',
  All = 'all',
}
